<script setup lang="ts">
  import { useActivityStore } from '@/stores/activity.ts';
  import dayjs from 'dayjs';
  import { computed } from 'vue';
  import { LocationTypes } from '@/utils/item-printer.ts';

  const activity = useActivityStore();

  function fmtSeconds(seconds: number) {
    const dur = dayjs.duration(seconds, 'seconds');
    const h = dur.hours();
    const m = dur.minutes();
    const hours = h > 0 ? `${h}시간` : '';
    const minutes = m > 0 ? ` ${m}분` : '';

    return `${hours}${minutes}` || '0분';
  }
  function findLocationText(location?: string) {
    if (!location) return undefined;

    return LocationTypes.find((locationType) => locationType.value == location)
      ?.text;
  }

  const today = computed(() => ({
    workStarted: dayjs(activity.summary?.workStartDt).format('A hh시 mm분'),
    workEnded: dayjs(activity.summary?.workEndDt).format('A hh시 mm분'),
    workTime: fmtSeconds(activity.summary?.workTime ?? 0),
    selfBreakTime: fmtSeconds(activity.summary?.selfBreakTime ?? 0),
    statutoryBreakTime: fmtSeconds(activity.summary?.statutoryBreakTime ?? 0),
    location: findLocationText(activity.summary?.location),
  }));
</script>

<template>
  <div class="px-1 pb-3 text-sm leading-7">
    <p>
      근무 시작 시간
      <span class="float-right">{{ today.workStarted }}</span>
    </p>
    <p v-if="activity.isEnded">
      근무 종료 시간
      <span class="float-right">{{ today.workEnded }}</span>
    </p>
    <p>
      근무 시간
      <span class="float-right">{{ today.workTime }}</span>
    </p>
    <p>
      근무외 시간
      <span class="float-right">{{ today.selfBreakTime }}</span>
    </p>
    <p>
      휴게 시간
      <span class="float-right">{{ today.statutoryBreakTime }}</span>
    </p>
    <p v-if="today.location">
      근무 위치
      <span class="float-right">{{ today.location }}</span>
    </p>
  </div>
</template>
